import { render, staticRenderFns } from "./SpecialAreaSelectV1.vue?vue&type=template&id=8453b9f0&"
import script from "./SpecialAreaSelectV1.vue?vue&type=script&lang=js&"
export * from "./SpecialAreaSelectV1.vue?vue&type=script&lang=js&"
import style0 from "./SpecialAreaSelectV1.vue?vue&type=style&index=0&lang=less&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports